import configInit from './init'

window.AppConfig = {
  subDomain: configInit.subDomain,
  webUrl: configInit.subDomain,
  baseApiUrl: configInit.subDomain + '/',
  apiUrl: configInit.subDomain + '/api/v1/',
  webSocketUrl: configInit.subDomain + '/ws',
  clientId: 'iqs-web-admin',
  clientSecret: 'd979e29f23f',
  // clientSecret: 'a78b4e9f01d',
  // clientId: 'iqs-mobile-app',
  googleApiKey: 'AIzaSyCS_gZ0HyF1YOhmWqgOtd0xX3LwrBUr7Ms',
  fbase: {
    initializeConfig: {
      apiKey: 'AIzaSyDRs3Tc1Lzv1IS7Kl8SF_poirne3oagCX0',
      authDomain: 'xtend-erp-dev.firebaseapp.com',
      databaseURL: 'https://xtend-erp-dev.firebaseio.com',
      projectId: 'xtend-erp-dev',
      storageBucket: 'xtend-erp-dev.appspot.com',
      messagingSenderId: '20308770906',
      appId: '1:20308770906:web:c5cd7925c832851961d863',
      measurementId: 'G-CWC12BWC2T'
    },
    vapidKey: 'BP0np67MdCzjkxgsZqO3GIDwU3pB8IuqOCveNQOrqdrcQqZEB26lhfTgAWaG8x5hW2dsoYi1Dps4qY-BiV-8JQg'
  },
  IntervalRefreshData: 120000,
  IntervalRefreshDataDashboard: 300000,
  dateFormat: 'DD-MM-YYYY hh:mm:ss A',
  shortDateFormat: 'DD-MM-YYYY'
}
